'use strict';

window.STROKE_POLYLINE = {
  color: '#222',
  weight: 5,
  opacity: 0.5
};


// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('TrackingService', function($http, $q, $filter) {
  return {
    users: function(filters) {
      const request = {
        gleba: (typeof filters.gleba === 'number' ? filters.gleba : filters.gleba.id) || null,
        data_inicial: filters.dataInicial || filters.dia,
        data_final: filters.dataFinal || filters.dia
      };
      return $http.get(`${SERVER + API_VERSION }tracking/usuarios`, { params: request });
    },

    lastSendingUsers: function() {
      return $http.get(`${SERVER + API_VERSION }tracking/usuarios_ultimo_envio`);
    },

    lastSendingMaquinas: function() {
      return $http.get(`${SERVER + API_VERSION }tracking/rastreamento_gps`);
    },

    list: function(filters) {
      const request = {
        usuario: filters.usuario || null,
        propriedade: (filters.propriedade || {}).id || null,
        gleba: filters.gleba.id || null,
        dia: filters.dia || null,
        maquinas: filters.maquina || null
      };

      return $http.get(`${SERVER + API_VERSION }tracking`, { params: request });
    },

    listForGoogleMaps: function(filters) {
      const deferred = $q.defer();
      const self = this;

      self.list(filters).then(function(data) {
        const trackings = [];
        if (data.data.length <= 0) {
          deferred.resolve([]);
        } else {
          const dados = data.data;
          const id = 0;
          self.processDados({ dados, trackings, id, filters });
          deferred.resolve(trackings);
        }
      }, function(error) {
        deferred.reject(error);
      });

      return deferred.promise;
    },

    // eslint-disable-next-line max-lines-per-function
    processDados: function({ dados, trackings, id, filters }) {
      const getCoordinate = function(object) {
        return { lat: object.latitude, lng: object.longitude };
      };
      dados.forEach(function(item, index) {
        const lastTracking = trackings[trackings.length-1];
        const hashLast = lastTracking ? `${lastTracking.usuario }.${ lastTracking.gleba}` : '';
        const hash = `${item.usuario_id }.${ item.gleba_id}`;
        const trocou = index > 0 && hashLast !== hash;
        const saiu = item.status === 'S';

        if (index === 0 || saiu || trocou) {
          trackings.push({
            usuario: item.usuario_id,
            object: item,
            idKey: id,
            title: item.usuario,
            gleba: item.gleba_id,
            inicio: item.recorded_at,
            fim: item.recorded_at,
            path: [getCoordinate(item)],
            strokeColor: filters.cor || STROKE_POLYLINE.color,
            strokeWeight: STROKE_POLYLINE.weight,
            strokeOpacity: STROKE_POLYLINE.opacity,
            editable: false,
            draggable: false,
            geodesic: false,
            visible: true,
            zIndex: 9999
          });
        } else {
          trackings[trackings.length-1].path.push(getCoordinate(item));
          trackings[trackings.length-1].fim = item.recorded_at;
        }
      });
    },

    getGlebasVisitadas: function(filters) {
      filters.maquinas = filters.maquina || null;
      return $http.get(`${SERVER + API_VERSION}tracking/glebas_data`, { params: filters });
    },

    // eslint-disable-next-line complexity
    getContentInfoWindow: function(polygon) {
      if (!polygon || !polygon.coordinate) {
        return '';
      }

      if (polygon.coordinate.raw_payload_data) {
        return polygon.coordinate.raw_payload_data;
      }

      const formatNumber = (value) => $filter('number')(value, 2);

      const formatDate = $filter('date')(polygon.coordinate.time || polygon.coordinate.recorded_at, 'dd/MM/yyyy HH:mm');

      return `
        ${polygon.coordinate.speed ? `Velocidade: ${formatNumber(polygon.coordinate.speed)} km/h <br>` : ''}
        ${polygon.coordinate.altitude ? `Altitude: ${formatNumber(polygon.coordinate.altitude)} m <br>` : ''}
        ${polygon.coordinate.time || polygon.coordinate.recorded_at ? `Data/hora: ${formatDate}` : ''}
      `;
    }
  };
});
